<template>
  <p class="c-message__countdown" id="countdown" v-if="display">
    <span><span id="days">{{ days }}</span>Days</span>
    <span><span id="hours">{{ hours }}</span>Hours</span>
    <span><span id="minutes">{{ minutes }}</span>Minutes</span>
    <span><span id="seconds">{{ seconds }}</span>Seconds</span>
  </p>
</template>


<script>

export default {
  name: "Countdown",
  props: {
    launchDate: {
      type: Number,
      required: true,
    }
  },
  data() {

    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      display: false
    }
  },
  mounted() {
    this.startCountdown()
  },
  methods: {
    startCountdown() {
      const second = 1000,
          minute = second * 60,
          hour = minute * 60,
          day = hour * 24

      const launchDate = new Date(this.launchDate * 1000).getTime()

      const interval = setInterval(() => {
        const currentDate = new Date().getTime()
        const distance = launchDate - currentDate
        this.days = Math.floor(distance / (day))
        this.hours = Math.floor((distance % (day)) / (hour))
        this.minutes = Math.floor((distance % (hour)) / (minute))
        this.seconds = Math.floor((distance % (minute)) / second)
        this.display = true

        if (distance < 0) {
          clearInterval(interval);
          this.display = false
        }
      }, 0)
    }
  }
};
</script>



<style scoped>

</style>
